<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created(){
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?cc9eec7a19f300c80346e5b92ee9862e";
      var s = document.getElementsByTagName("script")[0]; 
      s.parentNode.insertBefore(hm, s);
    })();

  }
}
</script>

<style>
  /* 滚动条宽度 */
  ::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }

  /* 滚动条的滑块 */
  ::-webkit-scrollbar-thumb {
    background-color: #c0ccda;
    border-radius: 6px;
  }
</style>
